import { formatScaled, parseScaled } from "./decimal";

export function toPct4(input: string): number {
  return parseScaled(input, 4, "invalid_pct");
}

export function formatPct(pct4: number): string {
  return `${formatScaled(pct4, 4, 0)}%`;
}
